import { render, staticRenderFns } from "./FootButton.vue?vue&type=template&id=77366c03&"
import script from "./FootButton.vue?vue&type=script&lang=js&"
export * from "./FootButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports